export function formatVersionForHelpUrl(p360Version?: string): string {
    const version = p360Version?.replace("Version", "").trim();
    return `${version?.split('.')[0]}.${version?.split('.')[1]}`;
}

export const isOutlookApp = ():boolean=>{
   return Office.context.diagnostics.host === Office.HostType.Outlook;
   //(Office.context.diagnostics.host === Office.HostType.Word || Office.HostType.PowerPoint || Office.HostType.Excel
};